import React from "react";
import { Box } from "@material-ui/core";

const FixedBottomBar = ({ children }) => {
    return (
        <Box
            display="flex"
            flexDirection="row-reverse"
            width="100%"
            padding={1}
            style={{
                position: "fixed",
                bottom: 0,
                right: 0,
            }}
            bgcolor="rgba(0,0,0, 0.1)"
        >
            {children}
        </Box>
    );
};

export { FixedBottomBar };
